// extracted by mini-css-extract-plugin
export default {"layoutWrapper":"styles_layoutWrapper__TuJAw","layoutChildren":"styles_layoutChildren__zqvz5"};